// Starter templates for an empty dashboard summary: prewritten prompts a user clicks to load into
// the prompt box. One file per template so the prose stays out of component code, and so adding a
// fourth is a new file plus one line here.
//
// These are client-side only. There are no dashboard templates on the backend, and none are needed —
// a template is just text handed to the same `dashboard-ai-generate` endpoint a typed prompt uses.
import { chartsTemplate } from './charts';
import type { DashboardTemplate } from './dashboardTemplate.types';
import { totalsTemplate } from './totals';
import { valuationsTemplate } from './valuations';

// Display order, left to right.
export const DASHBOARD_PROMPT_TEMPLATES: readonly DashboardTemplate[] = [
  totalsTemplate,
  chartsTemplate,
  valuationsTemplate,
];

export type { DashboardTemplate, DashboardTemplatePreviewTile } from './dashboardTemplate.types';
